// src/components/postAd/CategoryPicker.js
import React, { useState } from 'react';
import { usePostAd } from '../../contexts/PostAdContext';
import { CATEGORIES_DATA } from '../../constants/Categories';
import { FiChevronRight, FiArrowLeft } from 'react-icons/fi';
import './CategoryPicker.css';

const CategoryPicker = () => {
  const { setStep, setSelectedCategory, setSelectedSubCategory } = usePostAd();
  const [view, setView] = useState('CATEGORIES'); 
  const [activeCat, setActiveCat] = useState(null);

  // Mapping your provided icon paths to IDs
  const getIconForCat = (id) => {
    const iconMap = {
      'c1': 'assets/icons/car_category.png',
      'c2': 'assets/icons/bike_category.png',
      'c3': 'assets/icons/properties_category.png',
      'c4': 'assets/icons/electronics_category.png',
      'c5': 'assets/icons/mobiles_category.png',
      'c7': 'assets/icons/furniture_category.png',
      'c8': 'assets/icons/books_sports_category.png',
      'c9': 'assets/icons/Fashion.png',
      'c10': 'assets/icons/services_category.png',
      'c11': 'assets/icons/everything_else.png',
    };
    return iconMap[id] || 'assets/icons/electronics_category.png';
  };

  const getIconForSubCat = (id) => {
    const iconMap = {
      'c1': {
        'maruti suzuki': 'assets/sub_categories/cars/maruti_suzuki_cars_logo.png',
        'hyundai': 'assets/sub_categories/cars/hyundai_cars_logo.png',
        'honda': 'assets/sub_categories/cars/honda_cars_logo.png',
        'toyota': 'assets/sub_categories/cars/toyota_cars_logo.png',
        'tata': 'assets/sub_categories/cars/tata_cars_logo.png',
        'mahindra': 'assets/sub_categories/cars/mahindra_cars_logo.png',
        'bmw': 'assets/sub_categories/cars/bmw_cars_logo.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c2': {
        'bicycles': 'assets/sub_categories/bikes/sub_category_bicycles.png',
        'motorcycles': 'assets/sub_categories/bikes/sub_category_bikes.png',
        'scooters': 'assets/sub_categories/bikes/sub_category_scooters.png',
        'spare parts': 'assets/sub_categories/bikes/sub_category_spare_parts.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c3': {
        'lands & plots': 'assets/sub_categories/properties/cat_6_lands.png',
        'houses & apartments': 'assets/sub_categories/properties/sub_category_for_rent_houses_and_apartments.png',
        'shops & offices': 'assets/sub_categories/properties/sub_category_for_rent_shops_and_offices.png',
        'sale house & apartments': 'assets/sub_categories/properties/sub_category_for_sale_house_and_apartments.png',
        'sale shops & offices': 'assets/sub_categories/properties/sub_category_for_sale_shops_and_offices.png',
        'pg & guest houses': 'assets/sub_categories/properties/sub_category_pg_and_guest_houses.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c4': {
        'acs': 'assets/sub_categories/electronics_and_appliances/sub_category_acs.png',
        'cameras': 'assets/sub_categories/electronics_and_appliances/sub_category_cameras_and_lenses.png',
        'accessories': 'assets/sub_categories/electronics_and_appliances/sub_category_computer_accessories.png',
        'computers & laptops': 'assets/sub_categories/electronics_and_appliances/sub_category_computers_and_laptops.png',
        'fridges': 'assets/sub_categories/electronics_and_appliances/sub_category_fridges.png',
        'games & entertainment': 'assets/sub_categories/electronics_and_appliances/sub_category_games_and_entertainment.png',
        'printers & monitors': 'assets/sub_categories/electronics_and_appliances/sub_category_hard_disks_printers_monitors.png',
        'kitchen appliances': 'assets/sub_categories/electronics_and_appliances/sub_category_kitchen_and_other_appliances.png',
        'tvs & audio': 'assets/sub_categories/electronics_and_appliances/sub_category_tvs_video_audio.png',
        'washing machines': 'assets/sub_categories/electronics_and_appliances/sub_category_washing_machines.png',
        'wearables': 'assets/sub_categories/electronics_and_appliances/subcategories_qinto_transparent.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c5': {
        'accessories': 'assets/sub_categories/mobiles/cat_4_accessories.png',
        'mobile phones': 'assets/sub_categories/mobiles/cat4_mobile_phones.png',
        'tablets': 'assets/sub_categories/mobiles/cat4_tablets.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c7': {
        'beds & wardrobes': 'assets/sub_categories/furniture/cat_5_beds_and_wardrobes.png',
        'home decor & garden': 'assets/sub_categories/furniture/cat_5_home_decor_and_garden.png',
        'kids furniture': 'assets/sub_categories/furniture/cat_5_kids_furniture.png',
        'other household items': 'assets/sub_categories/furniture/cat_5_other_household_items.png',
        'sofa & dining': 'assets/sub_categories/furniture/cat_5_sofa_and_dining.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c8': {
        'books': 'assets/sub_categories/books_and_sports/cat_7_books.png',
        'gym & fitness': 'assets/sub_categories/books_and_sports/cat_7_gym_and_fitness.png',
        'musical instruments': 'assets/sub_categories/books_and_sports/cat_7_musical_instruments.png',
        'other hobbies': 'assets/sub_categories/books_and_sports/Cat_7_Other_hobbies.png',
        'sports equipment': 'assets/sub_categories/books_and_sports/Cat_7_Sports_equipment.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c9': {
        'fashion': 'assets/sub_categories/fashion/Fashion.png',
        'jewelry': 'assets/sub_categories/fashion/Jewellery.png',
        'kids fashion': 'assets/sub_categories/fashion/kids_fashion.png',
        'men\'s wear': 'assets/sub_categories/fashion/mens_fashion.png',
        'women\'s wear': 'assets/sub_categories/fashion/womens_fashion.png',
          'others': 'assets/icons/everything_else.png',
      },
      'c10': {
        'cleaning & pest control': 'assets/sub_categories/services/cleaning_and_pest_control.png',
        'education & classes': 'assets/sub_categories/services/education_classes.png',
        'electronics repair & services': 'assets/sub_categories/services/electronics_and_repair_services.png',
        'health & beauty': 'assets/sub_categories/services/health_and_beauty.png',
        'home renovation & repair': 'assets/sub_categories/services/home_and_renovation_repair.png',
        'legal & documentation services': 'assets/sub_categories/services/legal_and_documentation_services.png',
        'other services': 'assets/sub_categories/services/other_services.png',
        'packers & movers': 'assets/sub_categories/services/packers_and_movers.png',
        'tours & travel': 'assets/sub_categories/services/tours_and_travel.png',
        'others': 'assets/icons/everything_else.png',
      },
      'c11': 'assets/icons/everything_else.png',
    };
    return iconMap[id] || 'assets/icons/electronics_category.png';
  };

  const handleCategoryClick = (cat) => {
    if (cat.subCategories && cat.subCategories.length > 0) {
      setActiveCat(cat);
      setView('SUBCATEGORIES');
    } else {
      setSelectedCategory(cat.id);
      setSelectedSubCategory(null);
      setStep(3);
    }
  };

  const handleSubCategoryClick = (sub) => {
    setSelectedCategory(activeCat.id);
    setSelectedSubCategory(sub.id);
    setStep(3); 
  };

  return (
    <div className="category-picker-container">
      {view === 'CATEGORIES' ? (
        <div className="animate-in">
          <div className="picker-header-main">
            <button className="back-nav-btn" onClick={() => setStep(1)}>
              <FiArrowLeft /> Back
            </button>
            <h2>Select Category</h2>
          </div>
          
          <div className="category-grid">
            {CATEGORIES_DATA.map(cat => (
              <div key={cat.id} className="cat-card" onClick={() => handleCategoryClick(cat)}>
                <div className="cat-image-wrapper">
                  <img src={getIconForCat(cat.id)} alt={cat.title} />
                </div>
                <p>{cat.title}</p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="animate-in">
          <div className="picker-header-sub">
            <button className="back-nav-btn" onClick={() => setView('CATEGORIES')}>
              <FiArrowLeft /> Back to Categories
            </button>
            <h2>{activeCat.title}</h2>
          </div>
          
          <div className="sub-category-list">
            {activeCat.subCategories.map(sub => (
              <div key={sub.id} className="sub-item" onClick={() => handleSubCategoryClick(sub)}>
                {/* <span>{sub.name}</span> */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <img 
                    src={getIconForSubCat(activeCat.id)[sub.name.toLowerCase()] || 'assets/icons/default_subcategory.png'} 
                    alt={sub.name} 
                    style={{ width: '40px', height: '40px', objectFit: 'contain', borderRadius: '8px' }}
                    onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }}
                  />
                  <span style={{ fontWeight: '500' }}>{sub.name}</span>
                </div>
                <FiChevronRight className="arrow-icon" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryPicker;